const products_data = [
    {
        id: 1,
        name: 'Galaxy S23 Ultra',
        price: 124999.00,
        img: 'https://images.samsung.com/in/smartphones/galaxy-s23-ultra/buy/product_color_green.png',
        features: [
            "200 MegaPixels Wow - worthy resolution",
            "World's fastest Snapdragon9",
            "UFS 4.0 storage and LPDDR5X RAM",
            "Dynamic AMOLED 2X 120Hz Display",
            "Intelligent 5000mAh Battery",
            "Gorilla Glass Victus 2"
        ]
    },
    {
        id: 2,
        name: 'Galaxy A23 5G',
        price: 24999.00,
        img: 'https://specifications-pro.com/wp-content/uploads/2021/12/Samsung-Galaxy-A23-5G-1-scaled-600x600.jpg',
        features: [
            "50 MegaPixels OIS camera",
            "Snapdragon 695 5G chipset",
            "6.6-inch 120Hz screen",
        ]
    },
    {
        id: 3,
        name: 'Galaxy Z Fold4',
        price: 146999.00,
        img: 'https://images.samsung.com/in/smartphones/galaxy-z-fold4/buy/Fold4_ColorSelection_GrayGreen_PC.png',
        features: [
            "50MP sensor with an f/1.8 lens and optical stabilization",
            "3x optical zoom",
            "120Hz Smooth gaming Smooth viewing",
            "The first foldables that can take on water"
        ]
    },
    {
        id: 4,
        name: 'Galaxy Z Flip4',
        price: 82999.00,
        img: 'https://images.samsung.com/in/smartphones/galaxy-z-flip4/buy/05_Flip4_Bespoke_ColorSelection_top5_black_khaki_khaki_MO.png',
        features: [
            "Ultra Thin Glass",
            "Advanced durability makes it stronger",
            "Still unafraid of water",
            "Nightography on the Rear Camera"
        ]
    },
    {
        id: 5,
        name: 'Galaxy M53 5G',
        price: 27999.00,
        img: 'https://m.media-amazon.com/images/I/810Rscvmd4L._SL1500_.jpg',
        features: [
            "108 MegaPixels Camera",
            "6.7-inch Super AMOLED 120Hz display",
            "Mediatek Dimensity 900 chipset",
            "25W fast charging"
        ]
    },
    {
        id: 6,
        name: 'Galaxy A73 5G',
        price: 41999.00,
        img: 'https://images.samsung.com/is/image/samsung/p6pim/in/feature/163996770/in-feature---531831046?$FB_TYPE_A_MO_JPG$',
        features: [
            "Snapdragon® 778G 5G",
            "6.7-inch Super AMOLED 120Hz display",
            "108MP Wide-angle camera",
            "5,000mAh battery with 25W fast charging",
            "Rated IP67 for water and dust-resistance"
        ]
    },
    {
        id: 7,
        name: 'Galaxy A53 5G',
        price: 33499.00,
        img: 'https://img.poorvika.com/cdn-cgi/image/width=1600,height=1600,quality=75/1600_JPG/Mobiles/Samsung/Samsung%20Galaxy%20A53%205G/AwesomeBlack/Samsung-Galaxy-A53-5G-AwesomeBlack-back.jpg',
        features: [
            "Super AMOLED 120Hz display",
            "Dual Speakers",
            "Excellent battery life",
            "micro SD expandable"
        ]
    },
    {
        id: 8,
        name: 'Galaxy A33 5G',
        price: 0,
        img: 'https://images.samsung.com/is/image/samsung/p6pim/in/feature/163950259/in-feature--thinsp--531437186?$FB_TYPE_A_MO_JPG$',
        features: [
            "6.4 inch Super AMOLED HDR10 90Hz Display",
            "Gorilla Glass 5",
            "Rated IP67 for water and dust-resistance",
            "48 MP quad camera with OIS"
        ]
    },
    {
        id: 9,
        name: 'Galaxy S22 Ultra',
        price: 109999.00,
        img: 'https://images.samsung.com/levant/smartphones/galaxy-s22-ultra/buy/S22Ultra_ColorSelection_Burgundy_MO.jpg',
        features: [
            "Faster S Pen built in",
            " 6.8-inch Dynamic AMOLED 120Hz Display",
            "108 MegaPixels Camera",
            "Faster 45W charging"
        ]
    },
    {
        id: 10,
        name: 'Galaxy S22',
        price: 52999.00,
        img: 'https://m.media-amazon.com/images/I/71HUnJvHsbL._SL1500_.jpg',
        features: [
            "Nightography camera",
            "Way beyond all-day battery",
            "Our fastest chip ever",
            "45W Power Adapter",
            "IP68 water resistance rating"
        ]
    },
    {
        id: 11,
        name: 'Galaxy S20 FE 5G',
        price: 29999.00,
        img: 'https://m.media-amazon.com/images/I/812yohjGZ2L._SY606_.jpg',
        features: [
            "Snapdragon 865 Octa-Core processor",
            "12MP Dual Pixel OIS Camera",
            "6.5-inch Super AMOLED 120Hz Display",
            "4500 mAh battery with Super Fast Charging",
            "IP68 Rated water resistance"
        ]
    },
    {
        id: 12,
        name: 'Galaxy S21 FE 5G',
        price: 38999.00,
        img: 'https://images.samsung.com/is/image/samsung/assets/in/2201/preorder/2_color_configurator/1_color_selection/S21FE_ColorSelection_Lavender_MO.jpg',
        features: [
            "6.4 inch Dynamic AMOLED 2X 120Hz display",
            "12 MegaPixels Triple Camera",
            "4500 mAh Battery",
            "Exynos 2100 SoC Chipset",
            "Super fast charging",
            "IP68 Rated water resistance"
        ]
    }
]

module.exports = products_data